import { render, staticRenderFns } from "./UserCurrentCourses.vue?vue&type=template&id=062ec6f8&"
import script from "./UserCurrentCourses.vue?vue&type=script&lang=js&"
export * from "./UserCurrentCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports